import { makeAutoObservable } from "mobx";
import hashController from "../../../template/controllers/hash.controller"
import translite from "../../../template/controllers/translite.controller"
import loaderController from "../../../template/loader/loader.controller";
import i from '../../../../translations/i'
import { openApi } from '../../../../helpers/request'
import { notification } from 'antd'

class propertiesController {

    constructor() {
        makeAutoObservable(this)
    }

    property = {
        type: 'checkbox',
        sorting: 500
    }
    properties = []

    propStore = []
    propDelete = []

    pagination = {
        total: 0,
        page: 1,
        limit: 10
    }

    product = []
    productLoadedKey = null
    productLoadingKey = null

    setOffset(e) {
        this.pagination.page = e
        this.getAllProperties()
    }

    getProperties(id = 0) {
        if(id > 0) {
            openApi('get', `/filters/${id}`)
                .then(result => {
                    console.log(result)
                    this.property = result.data
                })
                .catch(error => {

                })
        } else {
            openApi('get', `/filters?page=${this.pagination.page}&limit=${this.pagination.limit}`)
                .then(result => {
                    console.log(result)
                    this.properties = result.data
                    this.pagination.page = result.page
                    this.pagination.total = result.total
                    this.pagination.limit = result.limit
                })
                .catch(error => {

                })
        }
    }

    getAllProperties() {
        openApi('get', `/filters?page=${this.pagination.page}&limit=${this.pagination.limit}`)
            .then(result => {
                console.log(result)
                this.properties = result.data
                this.pagination.page = result.page
                this.pagination.total = result.total
                this.pagination.limit = result.limit
            })
            .catch(error => {

            })
    }

    setProperty(name, value) {
        this.property[name] = value
        if(name === "name") {
            this.property.namevalue = translite.translite(value)
        }
    }

    savePropForm(e) {
        e.preventDefault()
        this.saveProperty()
    }

    saveProperty() {
        let data = new FormData()
        data.append("name", this.property.name)
        data.append("namevalue", this.property.namevalue)
        data.append("type", this.property.type)
        data.append("sorting", this.property.sorting ?? "500")
        data.append("search", this.property.search ? 1 : 0)
        data.append("is_search", this.property.is_search ? 1 : 0)

        this.property.values && Array.isArray(this.property.values) && this.property.values.map((el, index) => {
            if(el.id && el.id > 0) data.append(`values[${index}][id]`, el.id)
            if(el.label) data.append(`values[${index}][label]`, el.label)
            data.append(`values[${index}][value]`, el.value)
            data.append(`values[${index}][position]`, el.position)
            data.append(`values[${index}][color_hex]`, el.color_hex)
            if(el.valuemin) data.append(`values[${index}][valuemin]`, el.valuemin)
            if(el.valuemax) data.append(`values[${index}][valuemax]`, el.valuemax)
        })

        openApi('post', `/filters/${this.property.id && this.property.id > 0 ? this.property.id : 0}`, data)
            .then(result => {
                if(this.property.id && this.property.id > 0) {
                    this.property = result

                    notification.success({
                        message: i.t('def:success.edit')
                    })

                    this.property = result.data

                } else {
                    document.location.href="/shop/properties"
                }
            })
            .catch(error => console.log(error.response))
    }

    delete(propertyID) {
        if(window.confirm(i.t('def:confirms.delete'))) {

            openApi('delete', `/filters/${propertyID}`)
                .then(result => this.getAllProperties())
                .catch(error => {})
        }

    }

    addPropertyValue(propertyID) {
        let array = this.property.values
        console.log(array)
        array.push({
            id: null,
            filtercategoryid: propertyID,
            label: "",
            value: "",
            ids: Date.now()
        })
        this.property.values = array

    }

    setVariant(type, id, value, pos="") {
        let elem
        if(type === "id") {
            this.property.values[this.property.values.findIndex(el => el.id === id)].value = value
            elem = this.property.values[this.property.values.findIndex(el => el.id === id)]
        } else if (type === "ids") {
            this.property.values[this.property.values.findIndex(el => el.ids === id)].value = value
            elem = this.property.values[this.property.values.findIndex(el => el.ids === id)]
        } else {
            this.property.values[this.property.values.findIndex(el => el[pos] === id)].position = value
            elem = this.property.values[this.property.values.findIndex(el => el[pos] === id)]
        }

        if(pos !== "") {
            if(this.propStore.findIndex(el => el[pos] === id) >= 0) {
                this.propStore[this.propStore.findIndex(el => el[pos] === id)] = elem
            } else {
                this.propStore.push(elem)
            }
        } else {
            if(this.propStore.findIndex(el => el[type] === id) >= 0) {
                this.propStore[this.propStore.findIndex(el => el[type] === id)] = elem
            } else {
                this.propStore.push(elem)
            }
        }
    }

    getPropertiesByCategories(categories, filterValues, force = false) {

        console.log(filterValues)

        const ids = categories && Array.isArray(categories)
            ? categories
                .map(el => typeof el === 'object' ? el.id : el)
                .filter(Boolean)
                .sort()
            : []

        const key = ids.join(',')

        if (!force && (this.productLoadedKey === key || this.productLoadingKey === key)) return

        this.productLoadingKey = key

        let uri = `props/filter?`

        ids.map(el => {
            uri += `ids[]=${el}&`
        })

        filterValues.map(el => uri += `selected[]=${el}&`)

        openApi('get', uri)
            .then(success => {
                this.product = success.data
                this.productLoadedKey = key
            })
            .catch(error => console.log(error.response))
            .finally(() => {
                this.productLoadingKey = null
            })
    }

    /**
     * Начинает новый запрос: обычный просмотр (search не задан) или новый
     * поиск (search задан и отличается от текущего). Пагинация обычного
     * просмотра и пагинация активного поиска считаются отдельно друг от
     * друга (browse_* и search_*), поэтому переключение между ними не сбивает
     * прогресс уже загруженного — см. loadMoreValues.
     * @param {number} categoryId
     * @param {number} limit
     * @param {string | undefined} search
     */
    getValuesByFilterCategory(categoryId, limit = 10, search = undefined) {
        const index = this.product.findIndex((el) => el.category.id === categoryId)

        if(index === -1) return

        const category = this.product[index].category

        if(category.values_loading) return

        if(!search) {
            // Очистка поиска — просто возвращаемся к обычному просмотру. Если
            // его первая страница уже когда-то грузилась, повторно её не
            // запрашиваем: следующий скролл сам продолжит browse-пагинацию.
            category.search_term = undefined
            if(category.browse_page !== undefined) return
            this._fetchValuesPage(category, categoryId, limit, undefined, 1, false)
            return
        }

        if(search === category.search_term) return

        category.search_term = search
        category.search_page = undefined
        category.search_exhausted = false
        this._fetchValuesPage(category, categoryId, limit, search, 1, true)
    }

    /**
     * Догрузка по скроллу. Пока у активного поиска остались страницы —
     * продолжает именно его; как только его результаты закончились (или
     * поиска нет), прозрачно переключается на дозагрузку обычного списка —
     * чтобы можно было докрутить до любого значения категории, даже если оно
     * не попало в текущий поиск.
     * @param {number} categoryId
     * @param {number} limit
     */
    loadMoreValues(categoryId, limit = 10) {
        const index = this.product.findIndex((el) => el.category.id === categoryId)

        if(index === -1) return

        const category = this.product[index].category

        if(category.values_loading) return

        if(category.search_term && !category.search_exhausted) {
            const page = (category.search_page ?? 0) + 1
            this._fetchValuesPage(category, categoryId, limit, category.search_term, page, false)
            return
        }

        if(category.browse_exhausted) return

        const page = (category.browse_page ?? 0) + 1
        this._fetchValuesPage(category, categoryId, limit, undefined, page, false)
    }

    _fetchValuesPage(category, categoryId, limit, search, page, prepend) {
        category.values_loading = true

        let uri = `/props/valuesByCategoryId/${categoryId}?page=${page}&limit=${limit}`
        if(search) uri += `&search=${encodeURIComponent(search)}`

        openApi('get', uri)
            .then(result => {
                const existingIds = category.values.map((el) => el.id)
                const newValues = result.data.filter((el) => !existingIds.includes(el.id))

                // В начало списка — только первая страница НОВОГО поиска (чтобы
                // результат поиска сразу был виден сверху). Все остальные
                // догрузки (следующие страницы поиска или обычного списка) —
                // в конец, туда, куда скроллит юзер.
                category.values = prepend ? [...newValues, ...category.values] : [...category.values, ...newValues]

                const exhausted = result.data.length < limit
                if(search) {
                    category.search_page = page
                    category.search_exhausted = exhausted
                } else {
                    category.browse_page = page
                    category.browse_exhausted = exhausted
                }
            })
            .catch(error => {

            })
            .finally(() => {
                category.values_loading = false
            })
    }

    deleteValue(id) {
        this.property.values = this.property.values.filter(el => el.id !== id)
        this.propDelete.push(id)
    }

}

export default new propertiesController()